"use client";
import { onCLS, onLCP, onINP, onTTFB, onFCP, Metric } from "web-vitals";
import { trackTyped, isAnalyticsReady } from "./gtag";

let initialized = false;

function report(metric: Metric) {
  try {
    if (!isAnalyticsReady()) return;
    trackTyped("web_vitals_report", {
      metric_name: metric.name,
      metric_id: metric.id,
      metric_value: metric.value,
      metric_rating: metric.rating,
      page_location:
        typeof window !== "undefined" ? window.location.href : undefined,
    });
  } catch (err) {
    // swallow any reporting errors to avoid impacting UX
    console.warn("Web Vitals report error", err);
  }
}

export function initWebVitals() {
  if (initialized) return;
  initialized = true;
  // Report all changes for CLS/INP; LCP/TTFB use defaults
  const changeOpts = { reportAllChanges: true } as any;
  onCLS(report, changeOpts);
  onLCP(report);
  onINP(report, changeOpts);
  onTTFB(report);
  onFCP(report);
}
